import React from "react";
import styled from "styled-components";

import Divider from "../../../Divider";
import UpdateNotice from "../../../UpdateNotice";

import {
	Root,
	DateTime,
	ConnectionQuality,
	User,
	SIP2,
	TaxiService,
	Language,
	Settings,
	Logout,
	Logo,
} from "./components";

const FreeSpace = styled.div`
	display: flex;
	align-items: center;
	min-width: 0;
`;

const Header: React.FC = () => (
	<Root align="center" gaps="32px" sizes="auto!*4 1fr auto!*">
		<Logo />
		<Divider orientation="vertical" size={34} color="#374752" />
		<DateTime />
		<ConnectionQuality />
		{/* Takes the free space: the indicator's hover zone is its own size (dev check G3).
			The «new version» notice sits at its start. */}
		<FreeSpace>
			<UpdateNotice />
		</FreeSpace>
		<Divider orientation="vertical" size="max" color="#374752" />
		<User />
		<Divider orientation="vertical" size="max" color="#374752" />
		<SIP2 />
		<Divider orientation="vertical" size="max" color="#374752" />
		<TaxiService />
		<Divider orientation="vertical" size="max" color="#374752" />
		<Language />
		<Divider orientation="vertical" size="max" color="#374752" />
		<Settings />
		<Divider orientation="vertical" size="max" color="#374752" />
		<Logout />
	</Root>
);

export default Header;
